export const FrontendFonts = {
  'Bebas Neue': 'Bebas Neue',
  'Crunch Chips': 'Crunch Chips',
} as const;
